import { render, staticRenderFns } from "./OperadorScreen.vue?vue&type=template&id=82f265b6&scoped=true&"
import script from "./OperadorScreen.vue?vue&type=script&lang=js&"
export * from "./OperadorScreen.vue?vue&type=script&lang=js&"
import style0 from "./OperadorScreen.vue?vue&type=style&index=0&id=82f265b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f265b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAppBar,VBtn,VIcon,VMain,VSpacer})
